
import RcObject from '@/domain/common/RcObject.js';

export default class RcPayload extends RcObject {
  
  constructor(data) {
    super(data);
  }

  valuesFor(key) {
    var map = this.data[key];
    if (map) {
      return new RcObject(map);
    }
    return new RcObject({});
  }
  
  getList(key) {
    return super.get(key);
  }

  count() {
    var value = this.data['count'];
    return value;
  }

  minorCount() {
    var value = this.data['minorCount'];
    return value;
  }

  majorCount() {
    var value = this.data['majorCount'];
    return value;
  }

  expiringPlatesCount() {
    var value = this.data['expiringPlatesCount'];
    return value;
  }

  expiringSafetiesCount() {
    var value = this.data['expiringSafetiesCount'];
    return value;
  }

  expiringLicensesCount() {
    var value = this.data['expiringLicensesCount'];
    return value;
  }
  
  expiredLicensesCount() {
    var value = this.data['expiredLicensesCount'];
    return value;
  }
  
  withCount(count) {
    this.data["count"] = count;
    return this;
  }

  withMinorCount(count) {
    this.data["minorCount"] = count;
    return this;
  }

  withMajorCount(count) {
    this.data["majorCount"] = count;
    return this;
  }

  withExpiringPlatesCount(count) {
    this.data["expiringPlatesCount"] = count;
    return this;
  }

  withExpiringSafetiesCount(count) {
    this.data["expiringSafetiesCount"] = count;
    return this;
  }

  total() {
    var value = this.data['total'];
    return value;
  }
  
  withTotal(total) {
    this.data["total"] = total;
    return this;
  }

  hasMultiCompany() {
    var value = this.data['multicompany'];
    if (value) {
      return true;
    }
    return false;
  }
}